<template>  
  <div class="orderdetail">
    <XR-head titleText="订单详情"></XR-head>
    <div class="order-state" v-if="!loaded"  :style="{  backgroundImage:'url('+siteConfig.MobileBgImage+')' }">
      <p class="state-text">{{orderDetail.StateName}}</p>
    </div>
    <!--
        <router-link :to="'/usercenter/Orderdelivery?orderNo='+orderDetail.OrderNo" class="" v-if="orderDetail.DeliveryTracking && orderDetail.DeliveryTracking[0].WuLiu">
      <div class="delivery" v-if="!loaded">
        <div class="leftIcon">
          <i class="fa fa-delivery"></i>
        </div>
        <div class="delivery-process">
          <div class="text">{{ orderDetail.DeliveryTracking[0].WuLiu.data.length>0?orderDetail.DeliveryTracking[0].WuLiu.data[0].context : orderDetail.DeliveryTracking[0].WuLiu.message}}</div>
        </div>
        <div class="rightIcon">
          <i class="fa fa-angle-right"></i>
        </div>
      </div>
    </router-link>
    -->
    <div style="background: white; padding:10px;" v-if="!loaded">
      <div style="margin-top:10px;background: white;line-height: 16px;font-size: 12px;">{{orderDetail.DeliveryTracking[0].LogisticsCompanyIdName}}</div>
      <div style="margin-top:10px;background: white;line-height: 16px;font-size: 12px;">运单号：{{orderDetail.DeliveryTracking[0].DeliveryNo}}</div>
    </div>
    <!-- <router-link to="/usercenter/address?redirecturl=/usercenter/address">
        <div class="receive-address">    
          <span style="line-height: 40px;font-weight: bold;" v-if="!receiveAddress.Receiver">请选择收货地址</span>
          <div class="mapIcon">
            <i class="fa fa-location"></i>
          </div>
          <div class="address-info" :style="{width:addressInfoWidth+'px'}" v-if="receiveAddress.Receiver">         
            <div class="contract">
              <span class="name">{{receiveAddress.Receiver}}</span>
              <span class="mobile">{{receiveAddress.Phone}}</span>
              
            </div>
            <div class="address-content">
              <span class="text">{{receiveAddress.DetailAddress}}</span>
            </div>
          </div>
          <div class="goIcon">
            <i class="fa fa-angle-right"></i>
          </div>
        </div>
      </router-link> -->
      <div class="receive-address">    
          <span style="line-height: 40px;font-weight: bold;" v-if="!receiveAddress.Receiver">请选择收货地址</span>
          <div class="mapIcon">
            <img src="/static/icon/address-location.png" />
          </div>
          <div class="address-info" :style="{width:addressInfoWidth+'px'}" v-if="receiveAddress.Receiver">         
            <div class="contract">
              <span class="name">{{receiveAddress.Receiver}}</span>
              <span class="mobile">{{receiveAddress.Phone}}</span>              
            </div>
            <div class="address-content">
              <span class="text">{{receiveAddress.Address}}</span>
            </div>
          </div>
        </div>

    <div class="order-list" v-if="!loaded">
      <div class="order-item">
        <div class="shopRow">          
            <!-- <div class="all-chk"><mu-checkbox class="cart-all-chk" :nativeValue="cartItem.ShopId" @change="shopClick(cartItem.ShopId)" uncheckIcon=":fa fa-circle-thin" checkedIcon=":fa fa-yes"/></div> -->
            <div class="shopName">
              <img :src="orderDetail.ShopLogo" class="shopLogo" />
              <div class="shopNameValue">
                <span>{{orderDetail.ShopName}}</span>
                <i class="fa fa-angle-right"></i>
              </div>
            </div>      
          </div> 
        <!-- <div class="shoptip">
          <img class="shop-logo" :src="orderDetail.ShopLogo" />
          <p class="shop-name">{{orderDetail.ShopName}}</p>
          <p class="state"></p>
        </div> -->
        <div class="hidden-scorll">
          <div class="suborder-item-list">
            <div class="suborder-item" v-for="orderItem in orderDetail.OrderItems" :key="orderItem.ItemId">              
              <router-link :to="'/retail/productDetail?skuId='+orderItem.SkuId">
                <img :src="orderItem.DetailImage?orderItem.DetailImage:IMGServer_URL+'/images/index-item-default.png'" onerror="this.src=IMGServer_URL+'/images/index-item-default.png'" class="order-img" />
              </router-link> 
              <div class="product-info" :style="{ width:suborderItemProductNameWidth+'px'}">                      
                <router-link :to="'/retail/productDetail?skuId='+orderItem.SkuId">
                  <p class="product-name">{{orderItem.ProductName}}</p>
                </router-link>
                <p class="attr">数量:{{orderItem.Quantity}} {{orderItem.Attribute}}</p>
                <p class="state">{{orderItem.StateName}}</p>
                <p class="price"><i class="fa fa-rmb"></i>{{orderItem.SalePrice.toFixed(2)}}</p>
                <router-link class="item-button sellservice-request" :to="'/usercenter/sellservicerequest?sellServiceType='+orderItem.SellServiceType+'&itemId='+orderItem.ItemId" v-if="orderItem.SellServiceType==3">申请退款</router-link>
                <router-link class="item-button sellservice-request" :to="'/usercenter/sellservicerequest?sellServiceType='+orderItem.SellServiceType+'&itemId='+orderItem.ItemId" v-if="orderItem.SellServiceType==1">申请售后</router-link>
                <router-link class="item-button" :to="'/usercenter/orderEvaluate?itemId='+orderItem.ItemId+'&skuId='+orderItem.SkuId" v-if="orderItem.State==2 && !orderItem.IsComment">评价</router-link>
                <button class="item-button receive" @click="orderItemConfrim(orderItem.ItemId)" v-if="orderDetail.DeliveryType==1 && orderItem.State==1">确认收货</button>
              </div>  
            </div>
          </div>
        </div>
        <div class="order-detail" v-if="!loaded">
          <div class="order-info">
            <div class="field"><span>订单编号  </span> {{orderDetail.OrderNo}}</div>
            <div class="field"><span>下单时间  </span> {{orderDetail.Time.CreateDateName}}</div>
            <div class="field payOverDate" v-if="orderDetail.State ==1"><span> 超时时间  </span><span class="payOverDateTime">{{payOverDateName}}</span></div>
            <div class="field" v-if="orderDetail.DeliveryType != 1">
              <span>自提码  </span>
              <span v-show="show"> {{orderDetail.OrderDelivery.PickUpPassword}}</span>
              <span v-show='!show' @click="show = !show" style="color:#000;padding: 0 10px;">查看自提码</span>
            </div>
          </div>
          <div style="width:90%;height:1px;margin: 0px 10px;border-top:1px dashed #eee"></div>
          <div class="order-info">
            <div class="field"><span>支付方式  </span> {{orderDetail.OrderPay.PayTypeName}}</div>
            <div class="field"><span>支付时间  </span> {{orderDetail.Time.PayDateName}}</div>
          </div>
          <div style="width:90%;height:1px;margin: 0px 10px;border-top:1px dashed #eee"></div>
          <div class="order-info">
            <div class="field"><span>配送方式  </span> {{orderDetail.OrderDelivery.ShippingMethodName}}</div>
            <div class="field"><span>期望配送日期  </span> {{ orderDetail.DeliveryType == 1 ? orderDetail.OrderDelivery.ShippingDateName:orderDetail.OrderDelivery.SelfPickUpDate}}</div>
            <template v-if="orderDetail.DeliveryType == 3">
              <div class="field"><span>自提点 </span> {{orderDetail.OrderDelivery.CompanyName}}</div>
              <div class="field"><span>联系电话 </span> {{orderDetail.OrderDelivery.ContactPhone}}</div>
            </template>
          </div>
          <div style="width:90%;height:1px;margin: 0px 10px;border-top:1px dashed #eee"></div>
          <div class="order-info">
            <div class="field" style="margin:13px 0;"><span>发票抬头  </span>{{orderDetail.InvoiceHead}}</div>
          </div>
        </div>
      </div>
    </div>
    
    <div class="order-detail" v-if="!loaded">  
      <div class="order-info">
        <div class="field">
          <span class="title">商品总额</span>
          <span class="num"><i class="fa fa-rmb"></i>{{orderDetail.OrderMoney.ProductMoney.toFixed(2)}}</span>
        </div>
        <div class="field">
          <span class="title">运费</span>
          <span class="num"><i class="fa fa-rmb"></i>{{orderDetail.OrderMoney.FreightMoney.toFixed(2)}}</span>
        </div>
        <div class="field">
          <span class="title">已使用BAW</span>
          <span class="num">{{orderDetail.OrderMoney.DiscountMoney.toFixed(this.candyDecimal)}}BAW</span>
        </div>
        <div class="field" v-if="!closeCoupon">
          <span class="title">店铺优惠</span>
          <span class="num">-￥{{orderDetail.OrderMoney.StoreCouponMoney}}</span>
        </div>
        <div class="field" v-if="!closeCoupon">
          <span class="title">平台优惠</span>
          <span class="num">-￥{{orderDetail.OrderMoney.PlatformCouponMoney}}</span>
        </div>
        <div class="summary">
          <span class="title">实付款:</span>
          <span class="num"><i class="fa fa-rmb"></i>{{orderDetail.OrderMoney.CashMoney.toFixed(2)}}</span>
        </div>
      </div>
    </div>
	<div class="operator" v-if="!loaded && (orderDetail.State == 1 || orderDetail.State == 3 || (orderDetail.DeliveryType==1 && orderDetail.IsReceiver && (orderDetail.State==5 || orderDetail.State==6)))">
      <div v-if="orderDetail.State == 1" style="float:left;padding:0 10%;font-size:16px;font-weight:600;width:50%;height:100%;line-height:57px;">实付:<span style="color:red;">￥{{orderDetail.OrderMoney.CashMoney.toFixed(2)}}</span></div>
      <div class="button-list">
        <router-link :to="'/retail/orderPay?orderNo='+orderDetail.OrderNo" v-if="orderDetail.State == 1">
          <mu-raised-button label="付款" style="background-color:red;float:right;" class="button-item gobuy" primary></mu-raised-button>
        </router-link>
        <mu-raised-button label="取消订单" @click="orderCancel(orderDetail.OrderNo)" class="orderBtn button-item receive" style="background-color:#7C838B;color:#F2F2F3;float:right;" v-if="orderDetail.State ==1"></mu-raised-button>   
        <!-- <mu-raised-button label="再次购买" primary></mu-raised-button> -->
        <mu-raised-button label="确认收货" style="width:50%;background-color:red;" class="button-item" @click="orderConfrim" primary v-if="orderDetail.DeliveryType==1 && orderDetail.IsReceiver && (orderDetail.State==5 || orderDetail.State==6)"></mu-raised-button>
        <mu-raised-button label="修改地址" style="width:50%;background-color:red;" class="button-item" :to="'/usercenter/ordermodifyaddress?orderNo='+orderDetail.OrderNo" primary v-if="orderDetail.DeliveryType==1 && (orderDetail.State==3)"></mu-raised-button>
      </div>
    </div> 
    <XR-toast ref="XRtoast"></XR-toast>
  </div>
</template>

<script>
export default {
  data () {
    return {
      show:false,
      fullWidth:document.documentElement.clientWidth,
      suborderItemProductNameWidth: (parseInt(document.documentElement.clientWidth)-105),
      loaded:true,
      orderDetail:{},
      payOverDateName:'',
      siteConfig:{ MobileBgImage : '' },
      receiveAddress:{}, //收货地址信息
    }
  },
  mounted(){
    this.$refs.XRtoast.load()
    this.getSiteInfo()
    this.getOrderDetail()
  },
  methods: {
    getSiteInfo: function () {    
      const ths = this;
      this.$post('/Shop/SiteConfigServer/GetSiteConfig')
        .then(function (res) {
          if(res.IsSuccess){
            ths.siteConfig = res.Data
          }         
        })
        .catch(function (err) {
          console.log(err)
        })    
    }, 
    getOrderDetail(){    
     
      var ths = this;   
      ths.$post(
        "/Shop/RetailServer/GetOrderDetail",
        JSON.stringify({orderno: this.$route.query.orderNo})
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{    
          ths.loaded =false
          ths.orderDetail = res.Data
          ths.receiveAddress = res.Data.OrderDelivery
          ths.$refs.XRtoast.hide()
          if(res.Data.State == 1){
            var serverTime = res.Data.Time.ServerTime.replace('T',' ')
            serverTime = serverTime.replace(new RegExp('-','g'),"/")
            var ts = (new Date(serverTime))-(new Date());
            var overDate = res.Data.Time.PayOverDate.replace('T',' ')
            overDate = overDate.replace(new RegExp('-','g'),"/")
            ths.calcPayOverDate(ts,overDate)
          }
        }
      });
    },
    calcPayOverDate(tmpTs, payOverDate){      
      var ths = this
      var interval = setInterval(function(){
        var ts = (new Date(payOverDate)) - (new Date()) - tmpTs; //计算剩余的毫秒数    
        if (ts <= 0) {
            ths.payOverDateName='已超时'
            clearInterval(interval);
            return;
        }
        var hh = parseInt(ts / 1000 / 60 / 60, 10); //计算剩余的小时数  
        var mm = parseInt(ts / 1000 / 60 % 60, 10); //计算剩余的分钟数  
        var ss = parseInt(ts / 1000 % 60, 10); //计算剩余的秒数 

        if(hh<10){
          hh= '0'+hh
        }
        if(mm<10){
          mm= '0'+mm
        }
        if(ss<10){
          ss= '0'+ss
        }

        ths.payOverDateName = hh+'时'+mm+"分"+ss+'秒' 
      },1000)
    },
    orderConfrim(){      
      var ths = this;   
      ths.$post(
        "/Shop/RetailServer/OrderConfrim",
        JSON.stringify({OrderNos: [this.orderDetail.OrderNo]})
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{    
          ths.$refs.XRtoast.success(res.Msg, true)
          ths.getOrderDetail()
        }
      });
    },
    orderItemConfrim(itemId){
      
      var ths = this;   
      ths.$post(
        "/Shop/RetailServer/OrderItemConfrim",
        JSON.stringify({orderItemNos: [itemId]})
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{    
          ths.$refs.XRtoast.success(res.Msg, true)
          ths.getOrderDetail()
          
        }
      });
    },
    orderCancel(orderNo){      
      var ths = this;   
      ths.$post(
        "/Shop/RetailServer/orderCancel",
        JSON.stringify({OrderNo: orderNo})
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{    
          ths.$refs.XRtoast.successCallback(res.Msg, function(){
            ths.getOrderDetail()
          })
        }
      });
    }
  }
}
</script>

<style>
.orderdetail .order-item .shopRow{
  background: white;
  overflow: hidden;
  color:#666;
  border-radius: 10px;
  width: 100%;
  padding: 15px 10px;
}
.orderdetail .order-item .shopRow .all-chk{
  float: left;
  width: 40px;
  margin-top: 6px;
  text-align: center;
}
.orderdetail .order-item .shopRow .shopName{
  padding-left: 10px;
  vertical-align: middle;
}
.orderdetail .order-item .shopRow .shopName .shopLogo{
  float: left;
  width:20px;
  height: 20px;
  border-radius: 50%;
}
.orderdetail .order-item .shopRow .shopName .shopNameValue{
  float: left;
  height: 20px;
  line-height: 20px;
  margin-left: 5px;
  font-size: 14px;
}
.orderdetail .goIcon{
  width: 20px;
  float: right;
  text-align: right;
}
.orderdetail .mapIcon{
  float: left;
  width: 30px;
  line-height: 40px;
}
.orderdetail .mapIcon img{
  width:100%;
  display: block;
  margin-top: 10px;
}
.orderdetail .receive-address{
  background: white;
  color:black;
  padding: 20px 25px;
  overflow: hidden;
  margin-top: 12px;
  border-radius: 10px;
}
.orderdetail .receive-address .address-info{
  float: left;
  margin-left: 10px;
  width: 85%;
}
.orderdetail .receive-address .address-info .name{
  font-size:16px;
  padding-right: 10px;
}
.orderdetail .receive-address .address-info .mobile{
  font-size:14px;
  color:#aaa;
}
.orderdetail .receive-address .address-info .address-content{
  font-size:12px;
  color:#666;
  line-height: 14px;
  height: 28px;
  margin-top: 5px;
}
.orderdetail .receive-address .address-info .address-content .fa{
  width: 20px;
}
.orderdetail .receive-address .goIcon{
  width:20px;
  height: 14px;
  margin-top: 29px;
}
#app .orderdetail{
  background: #eee;
  bottom:unset;
  padding-bottom: 56px;
}
.orderdetail .order-state{
  overflow: hidden;
  line-height: 60px;
  background: url(/static/us-top-bg.png);
  background-size: 100% 100%;
  color:white;
  padding-left: 15px;

}
.orderdetail .hidden-scorll{background-color: #FCFCFC;}
.orderdetail .delivery {
  overflow: hidden;
  background: white;
  padding:15px 10px;
  margin-top: 10px;
}
.orderdetail .delivery .fa{  
  width: 30px;
  margin-top: 4px;
}
.orderdetail .delivery .leftIcon {
  float:left;
}
.orderdetail .delivery .rightIcon {
  float:right;
  text-align: center;
  margin-top: -23px;
}
.orderdetail .delivery .delivery-process{
  overflow: hidden;
  padding-right: 40px;
}
.orderdetail .delivery-process .text{
  font-size: 12px;
  color:#999;
  line-height: 16px;
  height: 32px;
  word-break: break-all;
  overflow:hidden;
  text-overflow:ellipsis;
}

.orderdetail .order-delivery {
  overflow: hidden;
  background: white;
  border-radius: 10px;
  padding:10px;
  margin-top: 10px;
}
.orderdetail .order-delivery .fa {
  float:left;
  width: 30px;
  margin-top: 4px;
}
.orderdetail .order-delivery .delivery-info{
  overflow: hidden;
}
.orderdetail .order-delivery .delivery-info .member-info{
  overflow: hidden;
}
.orderdetail .order-delivery .member-info .username{
  float: left;
}
.orderdetail .order-delivery .member-info .mobile{
  float: left;
  margin-left: 14px;
}
.orderdetail .order-delivery .address{
  font-size: 12px;
  color:#999;
}

.orderdetail .order-list{
  /* border-radius: 10px; */
  overflow: hidden;
}
.orderdetail .order-item{
  border-radius: 10px;
  background: white;
  margin: 10px 0 0;
}
.orderdetail .shoptip{
  border-radius: 10px;
  overflow: hidden;
  background: white;
  padding:0 10px;
}
.orderdetail .shoptip .shop-logo{
  float: left;
  line-height: 48px;
  height: 24px;
  margin: 12px 12px 12px 0;
}
.orderdetail .shoptip .shop-name{
  float: left;
  line-height: 48px;
}
.orderdetail .shoptip .state{
  float: right;
  line-height: 48px;
}

.orderdetail .suborder-item-list{
  overflow: hidden;
  padding-left: 10px;
}
.orderdetail .suborder-item{
  width:100%;
  overflow: hidden;
  padding: 20px 0;
}
.orderdetail .suborder-item .order-img{
  width: 75px;
  height: 75px;
  object-fit: cover;
  float: left;
  padding: 1px;
  background: white;
}
.orderdetail .suborder-item .product-info{
  float: left;
  padding: 1px;
  margin-left: 10px;
  margin-right: 10px;
  word-break: break-all;
  height: 95px;
}
.orderdetail .suborder-item .product-info .product-name{
  word-break: break-all;
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
  line-height: 16px;
  font-size: 14px;
  padding-bottom: 10px;
  color:#333;
}
.orderdetail .suborder-item .product-info .attr{
  word-break: break-all;
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
  line-height: 14px;
  font-size: 12px;
  color:#999;
}
.orderdetail .suborder-item .product-info .state{
  word-break: break-all;
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
  line-height: 16px;
  font-size: 12px;
  margin-top: 14px;
  color:red;
}
.orderdetail .suborder-item .product-info .price{
  word-break: break-all;
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
  line-height: 16px;
  font-size: 12px;
  margin-top: 10px;
  float: left;
}
.orderdetail .suborder-item .product-info .item-button{
  float: right;
  height: 26px;
  line-height: 26px;
  font-size: 12px;
  margin-top: 6px;
  width: 60px;
  margin: 8px 0 0 0;
  padding:0;
  border: none;
  background: #f9f9f9;
  color:#999;
  border:1px solid #999;
  border-radius: 2px;
  margin-left: 10px;
  text-align: center;
}

.orderdetail .order-total{
  overflow: hidden;
}
.orderdetail .total-text{
  float: right;  
  font-size: 12px;
  line-height: 48px;
}
.orderdetail .total-text span{
  font-size: 14px;
}

.orderdetail .order-detail{
  border-radius: 10px;
  margin: 10px 0;
  background: white;
}
.orderdetail .order-info {
  padding: 10px 0;
}

.orderdetail .order-info .field{
  line-height: 24px;
  font-size: 12px;
  padding-left: 10px;
  padding-right: 10px;
  overflow: hidden;
  color:#999;
}
.orderdetail .order-info .field span{
  padding: 0 10px 0 0;
  color:#4D4A49;
}
.orderdetail .order-info .field .title{
  color:#3A3332;
  float: left;
}
.orderdetail .order-info .field .num{
  float: right;
  font-size: 14px;
}
.orderdetail .order-info .field .payOverDateTime{
  color:red;
}
.orderdetail .order-info .fa{
  font-size: 12px;
}
.orderdetail .order-info .summary{
  line-height: 16px;
  font-size: 16px;
  text-align: right;
  margin: 10px 0 0 10px;
  padding: 15px 10px 5px;
}
.orderdetail .order-info .summary .num{
  color:red;
}


.orderdetail .order-operator{
  height: 57px;
  overflow: hidden;
}
.orderdetail .order-operator .button-list{
  float: right;
  width: 100%;
}

.orderdetail .operator{  
  position: fixed;
  width: 100%;
  height: 57px;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: hidden;
  background: #f9f9f9;
}
.orderdetail .operator .button-list{
  /* width: 100%; */
  height: 100%;
  float: right;
}
.orderdetail .operator .button-list .button-item{
  /* widows: 40%;
  height: 100%;
  border:none; */
    height: 56px;
  background-color: rgb(244, 67, 54);
}
</style>



// WEBPACK FOOTER //
// src/pages/usercenter/orderdetail.vue